import { motion } from "framer-motion";
import { Users, Heart } from "lucide-react";

const Team = () => {
  const defaultProfileIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23D1D5DB'/%3E%3Cpath d='M100 50c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25zm0 60c-22.091 0-40 17.909-40 40v10h80v-10c0-22.091-17.909-40-40-40z' fill='%23FFFFFF'/%3E%3C/svg%3E";

  const teamMembers = [
    {
      name: "Mrs. Ritu",
      role: "Champion Farmer - Chakla Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/fh37r6uu_WhatsApp%20Image%202026-03-30%20at%2009.48.37.jpeg",
      description: "A progressive farmer championing organic practices in Chakla Village. She actively guides farmers in nearby villages to adopt environmentally responsible farming practices and has been instrumental in training farmers on Jeevamrit and Beejamrit.",
    },
    {
      name: "Mrs. Reena Kumari",
      role: "Champion Farmer - Panela Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/zquys1r8_reena.jpeg",
      description: "A dedicated farmer from Panela village practicing organic farming for the past five years and an active member of PAHAD Trust. She prepares her own Jeevamrita and sells excess to other farmers. Experiments with foxtail, finger, and proso millets.",
    },
    {
      name: "Sita",
      role: "Traditional Farmer - Goha Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/0qfepzse_WhatsApp%20Image%202026-03-30%20at%2009.48.38.jpeg",
      description: "In her 60s, Sita has spent decades nurturing her fields without chemical fertilizers. As part of Bhij Khojo Abhiyan by PAHAD Trust, she grew over 50 kg of Jou (barley) from just 1 kg of seeds.",
    },
    {
      name: "Mrs. Ayesha",
      role: "Leader - Paliur Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/rimlc0lu_ayesha.jpeg",
      description: "A determined and strong-willed farmer from Paliur, stands as an inspiring example of perseverance and leadership. She has become an active promoter of organic farming, not only practicing organic methods herself but also spreading awareness among other farmers.",
    },
    {
      name: "Madhuram",
      role: "Traditional Farmer - Bhalot Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/jpeumeg0_madhuram.jpeg",
      description: "At 70, Madhuram from Bhalot village stands as a living example of sustainable, chemical-free farming. For over 50 years, he has grown maize alongside kodra, wheat, siyon, and chillies. He rarely buys seeds, carefully saving the best stalks each season.",
    },
    {
      name: "Inder",
      role: "Young Farmer - Ghoa Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/z7l3jbcj_WhatsApp%20Image%202026-03-29%20at%2009.48.41.jpeg",
      description: "Age 22, balances taxi driving with organic farming. Grows maize, cauliflower, walnut, garlic, and other vegetables. Despite challenges from heavy rains and landslides, he continues practicing organic farming consistently.",
    },
    {
      name: "Bodhia Ram",
      role: "Reviving Bhalot's Organic Spirit",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/ry256l6q_tt.jpeg",
      description: "Farmer from Bhalot village leading a shift back to organic farming. Once known for abundant harvests of Rajma and Urad Dal, chemical fertilizers degraded their soil. With PAHAD Trust's support, he is returning to organic methods.",
    },
    {
      name: "Anant Kumar",
      role: "Former Teacher - Laira Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/9jwb7567_anant.jpeg",
      description: "From a teacher to a farmer, Anant's journey towards organic revival showcases transformation in farming practices. After connecting with PAHAD Trust, he participated in training programs that motivated him to transition to organic farming, producing organic manure and fodder for his animals.",
    },
    {
      name: "Chain Lal",
      role: "Retired Army Champion Farmer - Sunduh Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/xmv9lbi9_chain.jpeg",
      description: "A retired army professional who transitioned to organic farming. The Champion Farmer shared his journey of inspiring change in the Chamba district. With PAHAD Trust's guidance, he has started practicing organic farming on part of his land, focusing not just on crops but also on seed production.",
    },
    {
      name: "Desraj",
      role: "Traditional Farmer - Silla Gharat",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/otj1xa2n_desraj.jpeg",
      description: "Weekly meetings organized by PAHAD Trust have been a source of valuable learning and inspiration for Desraj. He emphasizes that using animals for sowing seeds is more effective than tractors. He drew inspiration from PAHAD Trust members who successfully produced high-value crops like cauliflower.",
    },
    {
      name: "Vyas Dev",
      role: "Strategic Farmer - Silla Gharat",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/pt5xpemb_vyas.jpeg",
      description: "As a proud member of PAHAD Trust, Vyas Dev gained valuable knowledge and successfully applied techniques on his field. During Rabi season, he received organic seeds from PAHAD Trust and implemented advanced farming practices. His journey has inspired over 150 farmers in the region to explore organic farming.",
    },
    {
      name: "Manju",
      role: "Farmer - 2 Years with PAHAD",
      image: defaultProfileIcon,
      description: "Has been with PAHAD for 2 years, received seeds. Grows gehu (wheat), makki (maize), kodra, and koni. Faces challenges like irregular rainfall, monkey damage, and landslides but remains committed to organic farming.",
    },
    {
      name: "Kiranwal",
      role: "Trained Farmer",
      image: defaultProfileIcon,
      description: "Has been with PAHAD Trust for 2 years. Received training on farming techniques including proper plant spacing. The training has made switching to organic farming easier and reduced the effort required.",
    },
    {
      name: "Deepika",
      role: "Multi-Crop Farmer",
      image: defaultProfileIcon,
      description: "Grows sarso (mustard), wheat, and makki (maize) for personal use and sale. Has slowly started including millet in diet. Also grows vegetables like potato, beans, and chili for personal consumption.",
    },
    {
      name: "Soni",
      role: "Kiwi Farmer",
      image: defaultProfileIcon,
      description: "Owns kiwi plants which have been selling for the last 2 years. It took 2 years for the kiwis to grow and mature. Faces challenges with monkeys frequently raiding the orchard.",
    },
    {
      name: "Uma (Gram Panchayat Pradhan)",
      role: "Lady Pradhan - Chakla Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/fycgq6x5_WhatsApp%20Image%202026-03-30%20at%2012.35.22.jpeg",
      description: "The Lady Pradhan reflected on how traditional farming practices once ensured healthier lives for her community. With PAHAD Trust's support, she and other farmers shifted to organic practices, growing crops like Kodra and certain pulses which are more resistant to monkey interference.",
    },
    {
      name: "Sobhia Ram",
      role: "Former Patwari - Paliur Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/q60xlcq9_WhatsApp%20Image%202026-03-30%20at%2012.35.25.jpeg",
      description: "A former Patwari who shared a heartfelt account of the drastic changes in farming over the years. Once a thriving hub for diverse crops, the region's agricultural landscape has suffered due to deteriorating soil health. PAHAD Trust offers hope through sustainable practices and traditional seeds.",
    },
    {
      name: "Basheer Muhammed",
      role: "Dairy Farmer - Paliur Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/k6olln12_WhatsApp%20Image%202026-03-30%20at%2012.35.23.jpeg",
      description: "A local dairy farmer who shared the challenges he faces in keeping his family's dairy farming legacy alive. For generations, his family thrived on producing high-quality dairy products. Today, he battles competition from large-scale corporations whose low-priced products have flooded the market.",
    },
    {
      name: "Ghimo Ram",
      role: "Head Farmer - Chakla Village",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/115g47la_WhatsApp%20Image%202026-03-30%20at%2012.35.24.jpeg",
      description: "The Head Farmer highlighted significant deforestation in nearby forests which has disrupted the local ecosystem. Monkeys continue to be a major problem during sowing stage. This year, rainfall arrived three months later than expected, disrupting crop rotation cycles.",
    },
    {
      name: "Women Farmers Collective",
      role: "Laira & Sunduh Villages",
      image: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/y1onprae_tt.jpeg",
      description: "For the past two years, farmers associated with PAHAD Trust have been transforming their approach to agriculture. They are now embracing sustainable practices like drinking millet tea and growing traditional crops using organic methods. They've successfully produced Kodra at competitive rates in local stores.",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/cham.jpeg')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/50" />
        </div>
        <div className="relative z-10 text-center max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Users className="h-16 w-16 text-white mx-auto mb-4" />
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-semibold text-white mb-6"
              style={{ textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}
            >
              Our Team
            </h1>
            <p className="text-lg text-white/90"
              style={{ textShadow: "0 1px 5px rgba(0,0,0,0.3)" }}
            >
              Meet the dedicated farmers and team members transforming Himalayan agriculture
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-24 bg-[#F9F8F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <Heart className="h-12 w-12 text-[#2B5C45] mx-auto mb-4" />
            <h2 className="text-3xl sm:text-4xl font-heading font-medium text-[#1C221F] mb-4">
              Champion Farmers & Team
            </h2>
            <p className="text-base text-[#515E58] max-w-2xl mx-auto">
              The heart of PAHAD Trust - dedicated individuals working towards sustainable agriculture and community empowerment
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`team-member-${index + 1}`}
                className="bg-white rounded-xl overflow-hidden shadow-sm border border-[#E4E2DC]/40 card-hover"
              >
                <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-heading font-medium text-[#1C221F] mb-2">
                    {member.name}
                  </h3>
                  <p className="text-sm text-[#8C9A74] font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-[#515E58] leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-16 bg-[#2B5C45]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <blockquote className="text-2xl sm:text-3xl font-heading font-medium text-white mb-4">
              "I've never needed chemicals. The soil and seeds know how to take care of themselves if you treat them right."
            </blockquote>
            <p className="text-lg text-white/80">- Madhuram, 70 years of organic farming</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Team;
